import React, { useContext } from "react";
// import * as emailjs from "emailjs-com"; // <-- Removed
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { meta } from "../../content_option";
import { Container, Row, Col } from "react-bootstrap"; // Alert removed
import { section_contact } from "../../content_option";
import { LanguageContext } from '../../data/language_context';

// Helper: determine suffix for language
const getLangKey = (selectedLang) => {
  switch (selectedLang) {
    case "Spanish": return "_esp";
    case "Catalan": return "_cat";
    case "English":
    default: return "_eng";
  }
};

export const ContactUs = () => {
  const { language: selectedLang } = useContext(LanguageContext);
  const langSuffix = getLangKey(selectedLang);

  // const [formData, setFormdata] = useState({ ... }); // <-- Form state removed

  // 🧩 Language-based UI text mapping
  const title = section_contact[`title${langSuffix}`] || "Contact Me";
  const getInTouch = section_contact[`get_in_touch${langSuffix}`] || "Get in touch";
  const description = section_contact[`description${langSuffix}`] || "";
  const labelEmail = section_contact[`label_email${langSuffix}`] || "Email:";
  const labelMobile = section_contact[`mobile${langSuffix}`] || "Mobile Phone:";
  // Form-related text variables removed

  // 📨 Handle form submission and change handlers removed

  // Minimal mock data to prevent errors in JSX for the loading bar class
  const formData = { loading: false };

  return (
    <HelmetProvider>
      <Container>
        <Helmet>
          <meta charSet="utf-8" />
          <link rel="icon" href={meta.logo} />
          <title>{meta.title} | Contact</title>
          <meta name="description" content={meta.description} />
        </Helmet>

        <Row className="mb-5 mt-3 pt-md-3">
          <Col lg="8">
            <h1 className="display-4 mb-4">{title}</h1>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>

        <Row className="sec_sp">
          {/* Form Alert section removed */}
          {/* <Col lg="12">...</Col> */}

          <Col lg="5" className="mb-5">
            <h3 className="color_sec py-4">{getInTouch}</h3>
            <address>
              <strong>{labelEmail}</strong>{" "}
              <a href={`mailto:${section_contact.YOUR_EMAIL}`}>
                {section_contact.YOUR_EMAIL}
              </a>
              <br /><br />
              {section_contact.MOBILE_PHONE && (
                <p>
                  <strong>{labelMobile}</strong> {section_contact.MOBILE_PHONE}
                </p>
              )}
            </address>
            <p>{description}</p>
          </Col>
        </Row>
      </Container>
      <div className={formData.loading ? "loading-bar" : "d-none"}></div>
    </HelmetProvider>
  );
};